<template>
  <div v-if="Math.round(Number(value)) > 0" class="ml-2 mb-2">
    <svg
      v-if="kind === 'increase'"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.09375 3.375L3.71875 0.625C3.79688 0.546875 3.89062 0.515625 4 0.515625C4.09375 0.515625 4.1875 0.546875 4.26562 0.625L6.89062 3.375C7.03125 3.53125 7.03125 3.76562 6.875 3.90625C6.73438 4.04688 6.48438 4.04688 6.34375 3.89062L4.375 1.8125V7.125C4.375 7.34375 4.20312 7.5 4 7.5C3.8125 7.5 3.625 7.34375 3.625 7.125V1.8125L1.64062 3.89062C1.5 4.04688 1.25 4.04688 1.10938 3.90625C0.953125 3.76562 0.953125 3.51562 1.09375 3.375Z"
        fill="#0088FF"
      />
    </svg>

    <svg
      v-else
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.90625 4.49072L4.28125 7.24072C4.20313 7.31885 4.10938 7.3501 4 7.3501C3.90625 7.3501 3.8125 7.31885 3.73438 7.24072L1.10938 4.49072C0.96875 4.33447 0.96875 4.1001 1.125 3.95947C1.26563 3.81885 1.51563 3.81885 1.65625 3.9751L3.625 6.05322L3.625 0.740723C3.625 0.521973 3.79688 0.365723 4 0.365723C4.1875 0.365723 4.375 0.521973 4.375 0.740723L4.375 6.05322L6.35938 3.9751C6.5 3.81885 6.75 3.81885 6.89063 3.95947C7.04688 4.1001 7.04688 4.3501 6.90625 4.49072Z"
        fill="#C62828"
      />
    </svg>
    <span style="font-size: 10px !important;" :style="{color: color}">{{isRound ? Math.round(Number(value)) : value}} {{percent ? '%' : '' }}</span>
  </div>
</template>

<script>
export default {
  props: {
    isRound: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Number],
    },
    kind: {
      type: String,
      default: 'increase',
    },
    percent: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};
</script>

<style>
</style>
